import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Button from "../../../../components/common/Button/Button";
import HomeSummaryModal from "../../../../components/newHomePolicy/modals/homeSummaryModal";
import ViewSummaryPopup from "../../../../components/newMotorPolicy/veiwSummaryPopup/viewSummaryPopup";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import useSummary from "../../../../hooks/useSummary";
import { getTokenOtpLoading } from "../../../../redux/features/account/accountOtpSlice";
import { getScanOwnershipLoading } from "../../../../redux/features/ai/scannerSlice";
import { selectBanksLoader } from "../../../../redux/features/constants/banksListSlice";
import { selectCarsLoader } from "../../../../redux/features/constants/carsListSlice";
import {
  getAdjustSumInsuredLoading,
  getDamageCheckbox,
  getInspectionDocsUploaded,
  getInspectionFailed,
  getQuoteWithRefundError,
  getQuoteWithRefundLoading,
  getQuoteWithRefundResponse,
} from "../../../../redux/features/endorsements/cancellationSlice";
import { getRequestPolicyTransferLoading } from "../../../../redux/features/endorsements/transferPolicySlice";
import { selectHomeFormData } from "../../../../redux/features/homeFormSlice";
import { getCalculatedPremiumLoader } from "../../../../redux/features/motor/calculatePremiumSlice";
import { ChangePlateNoLoading } from "../../../../redux/features/motor/ChangePlateNumberSlice";
import { gdtRetrieveVehicleLoading } from "../../../../redux/features/motor/gdtSlice";
import {
  getCoverPricesError,
  getCoverPricesLoading,
  getQuoteError,
  getQuoteLoading,
  getQuoteResponse,
} from "../../../../redux/features/motor/getQuoteSlice";
import { getSumInsuredLoader } from "../../../../redux/features/motor/getSumInsuredSlice";
import {
  getPolicyPremiumError,
  getPolicyPremiumLoading,
  getPolicyPremiumResponse,
} from "../../../../redux/features/motor/renewalPremiumSlice";
import {
  myPoliciesWholeLoader,
} from "../../../../redux/features/myPolicySlice";
import { selectNewMotorForm } from "../../../../redux/features/newMotorFormSlice";
import { selectTravelFormData } from "../../../../redux/features/newTravelFormSlice";
import { getAddCoversPolicyPayLoading } from "../../../../redux/features/payment/policyPaySlice";
import {
  tokenLoading,
  uploadLoading,
} from "../../../../redux/features/upload/fileUploadSlice";
import { currencyFormatter, formatPremiumValue } from "../../../../utils";
import { ADD_MORE_COVERS_POLICY_COVERAGE_ENHANCEMENT } from "../../addMOreCoversFlow/enhanceYourCoveragePage/enhanceYourCoveragePage";
export const COVERAGE_ENHANCEMENT = "COVERAGE_ENHANCEMENT";
export const ADD_COVERS_ENHANCEMENT_TRAVEL = "ADD_COVERS_ENHANCEMENT_TRAVEL";
export const TRAVEL_CHANGE_PLAN_SELECT_PLAN = "TRAVEL_CHANGE_PLAN_SELECT_PLAN";

const BottomStickyBtnLayout = ({
  children,
  btn_label,
  btn_onClick,
  btn_disabled,
  show_summary,
  price,
  included,
  carReplacement,
  AdditionalComponent,
  hideContinueBtn = false,
  passedFrom,
  isUploadingHistory,
  addonComponent,
  isLoading = false,
  quoteData = null,
}) => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [formState, setFormState] = useState({});
  const toggleShow = () => {
    setShow((state) => !state);
  };

  // Get home form data for home insurance modal
  const homeFormData = useSelector(selectHomeFormData);
  const {
    discount_amount,
    coverage_enhance_data,
    promocode,
    discount_percent,
    total_amount,
    // premium,
    discount,
    discount_percentage,
    vat_additional_amount,
  } = useSummary();

  const translate = useLanguageTranslate();
  // Loading indicator from redux. Would be better to have a global loading indicator for each API call, if needed
  const isCarListLoader = useSelector(selectCarsLoader);
  const isBanksListLoader = useSelector(selectBanksLoader);
  const isSumInsuredLoader = useSelector(getSumInsuredLoader);
  const isQuoteLoader = useSelector(getQuoteLoading);
  const isGdtLoader = useSelector(gdtRetrieveVehicleLoading);
  const isFilesLoading = useSelector(uploadLoading);
  const isTokenLoading = useSelector(tokenLoading);
  const isScannerLoading = useSelector(getScanOwnershipLoading);
  const isTokenOtpLoading = useSelector(getTokenOtpLoading);
  const isFetchPolicyLoading = useSelector(myPoliciesWholeLoader);
  const isPolicyPremiumLoading = useSelector(getPolicyPremiumLoading);
  const isCalculatePremiumLoading = useSelector(getCalculatedPremiumLoader);
  const isCoverPricesLoading = useSelector(getCoverPricesLoading);
  const isBankLoading = useSelector((state) => state.ScanBankLetter.status);
  const isQuoteWithRefundLoading = useSelector(getQuoteWithRefundLoading);
  const isRequestTransferLoading = useSelector(getRequestPolicyTransferLoading);
  const isChangePlateLoading = useSelector(ChangePlateNoLoading);

  const isInspectionDocsUploaded = useSelector(getInspectionDocsUploaded);
  const isInspectionUploadFail = useSelector(getInspectionFailed);
  const isInspectionDamageCheckbox = useSelector(getDamageCheckbox);

  const isPolicyPayAddCoversLoading = useSelector(getAddCoversPolicyPayLoading);

  const isAdjustSumInsuredLoading = useSelector(getAdjustSumInsuredLoading);

  // Quote details for price
  const quoteResponse = useSelector(getQuoteResponse);
  // Premium details for price
  const policyPremiumResponse = useSelector(getPolicyPremiumResponse);
  // Quote with refund
  const quoteWithRefundResponse = useSelector(getQuoteWithRefundResponse);

  const addCoverageEnhancement =
    useSelector(selectNewMotorForm)?.[
      ADD_MORE_COVERS_POLICY_COVERAGE_ENHANCEMENT
    ];

  const travelAddCoverageEnhancement =
    useSelector(selectNewMotorForm)?.[
      ADD_COVERS_ENHANCEMENT_TRAVEL
    ];

  const travelChangePlanSelection =
    useSelector(selectTravelFormData)?.[
      TRAVEL_CHANGE_PLAN_SELECT_PLAN
    ];

  // Errors to disable button
  const quoteResponseError = useSelector(getQuoteError);
  const policyPremiumError = useSelector(getPolicyPremiumError);
  const quoteWithRefundError = useSelector(getQuoteWithRefundError);
  const coveragePricesError = useSelector(getCoverPricesError);

  const coverageEnhanceData =
    useSelector(selectNewMotorForm)?.[COVERAGE_ENHANCEMENT];

  let premium = "";
  let tax = "";
  let totalPremium = "";
  if (passedFrom == "MotorNew") {
    premium =
      quoteResponse != ""
        ? quoteResponse.Premium
        : policyPremiumResponse.Premium;
    tax = quoteResponse != "" ? quoteResponse.Tax : policyPremiumResponse.Tax;
    totalPremium =
      quoteResponse != ""
        ? quoteResponse.TotalPremium
        : policyPremiumResponse.TotalPremium;

    // Add prices from coverage_enhance_data?.coverOptionsState if not empty
    if (coverage_enhance_data?.coverOptionsState?.length > 0) {
      const additionalPremium = coverage_enhance_data.coverOptionsState
        .filter(
          (option) =>
            option.included &&
            Number(option.price) > 0 &&
            !option.defaultIncludedInPlan &&
            !option.includedWithOther
        ) // Ensure price is a number
        .reduce((sum, option) => sum + Number(option.price), 0); // Convert price to number before summing

      totalPremium += additionalPremium + additionalPremium * 0.1;
      tax = (premium + additionalPremium) * 0.1;
    }
  } else if (passedFrom == "MotorRenewal") {
    premium = policyPremiumResponse != "" ? policyPremiumResponse.Premium : "-";
    tax = policyPremiumResponse != "" ? policyPremiumResponse.Tax : "-";
    totalPremium =
      policyPremiumResponse != "" ? policyPremiumResponse.TotalPremium : "-";

    // Add prices from coverage_enhance_data?.coverOptionsState if not empty
    if (coverage_enhance_data?.coverOptionsState?.length > 0) {
      const additionalPremium = coverage_enhance_data.coverOptionsState
        .filter(
          (option) =>
            option.included &&
            Number(option.price) > 0 &&
            !option.defaultIncludedInPlan &&
            !option.includedWithOther
        ) // Ensure price is a number
        .reduce((sum, option) => sum + Number(option.price), 0); // Convert price to number before summing

      totalPremium += additionalPremium + additionalPremium * 0.1;
      tax = (premium + additionalPremium) * 0.1;
    }
  } else if (passedFrom == "MotorChangeActivePlan") {
    premium = quoteWithRefundResponse.Premium;
    tax = quoteWithRefundResponse.Tax;
    totalPremium = quoteWithRefundResponse.TotalPremium;
  } else if (passedFrom == "HomeInsurance") {
    // For home insurance, use the price passed directly
    totalPremium = price || 0;
  } else if (passedFrom == "AddCovers") {
    // For Add Covers, calculate total premium from selected additional covers
    totalPremium = 0; // Initialize totalPremium
    premium = 0; // Initialize premium

    if (addCoverageEnhancement?.coverOptionsState?.length > 0) {
      // Calculate premium from additional covers that are selected and not already included in plan
      const additionalPremium = addCoverageEnhancement.coverOptionsState
        .filter(
          (option) =>
            option.included &&
            Number(option.price) > 0 &&
            !option.defaultIncludedInPlan &&
            !option.includedWithOther
        ) // Only covers that are selected and not default included
        .reduce((sum, option) => sum + Number(option.price), 0); // Sum the prices

      console.log(
        "Add Covers - Additional Premium from selected covers:",
        additionalPremium
      );
      console.log(
        "Add Covers - Selected covers:",
        addCoverageEnhancement.coverOptionsState.filter((opt) => opt.included)
      );

      premium = additionalPremium;
      tax = additionalPremium * 0.1; // 10% VAT on additional premium
      totalPremium = additionalPremium + tax; // Premium + VAT

      console.log("Add Covers - Final calculations:", {
        additionalPremium,
        tax,
        totalPremium,
      });
    }
  } else if (passedFrom == "TravelAddCovers") {
    // For Travel Add Covers, calculate total premium from selected additional covers
    totalPremium = 0; // Initialize totalPremium
    premium = 0; // Initialize premium

    if (travelAddCoverageEnhancement?.coverOptionsState?.length > 0) {
      // Calculate premium from additional covers that are selected and not already included in plan
      const additionalPremium = travelAddCoverageEnhancement.coverOptionsState
        .filter(
          (option) =>
            option.included &&
            Number(option.price) > 0 &&
            !option.defaultIncludedInPlan
        ) // Only covers that are selected and not default included
        .reduce((sum, option) => sum + Number(option.price), 0); // Sum the prices

      console.log(
        "Travel Add Covers - Additional Premium from selected covers:",
        additionalPremium
      );
      console.log(
        "Travel Add Covers - Selected covers:",
        travelAddCoverageEnhancement.coverOptionsState.filter((opt) => opt.included)
      );

      premium = additionalPremium;
      tax = additionalPremium * 0.1; // 10% VAT on additional premium
      totalPremium = additionalPremium + tax; // Premium + VAT

      console.log("Travel Add Covers - Final calculations:", {
        additionalPremium,
        tax,
        totalPremium,
      });
    } else if (price && price > 0) {
      // Fallback to price prop if Redux data not yet available
      console.log("Travel Add Covers - Using price prop as fallback:", price);
      totalPremium = price;
      premium = price / 1.1;
      tax = price - premium;
    }
  } else if (passedFrom == "TravelChangePlan") {
    // For Travel Change Plan, display selected plan premium
    totalPremium = 0; // Initialize totalPremium
    premium = 0; // Initialize premium

    if (travelChangePlanSelection) {
      console.log(
        "Travel Change Plan - Selected plan:",
        travelChangePlanSelection
      );

      // Use the selected plan's pricing
      premium = travelChangePlanSelection.premium || travelChangePlanSelection.totalPremium || 0;
      tax = travelChangePlanSelection.tax || premium * 0.1; // 10% VAT if not provided
      totalPremium = travelChangePlanSelection.totalPremium || (premium + tax); // Total premium

      console.log("Travel Change Plan - Final calculations:", {
        premium,
        tax,
        totalPremium,
      });
    } else if (price && price > 0) {
      // Fallback to price prop if Redux data not yet available (race condition fix)
      console.log("Travel Change Plan - Using price prop as fallback:", price);
      totalPremium = price;
      premium = price / 1.1; // Approximate base premium (total / 1.1)
      tax = price - premium; // Approximate VAT
    }
  } else if (passedFrom == "TravelRenewal") {
    // For Travel Renewal, use the price prop which contains the total premium from PolicyViewResponse
    if (price && price > 0) {
      totalPremium = price;
      premium = price / 1.1; // Approximate base premium (total / 1.1)
      tax = price - premium; // Approximate VAT
    } else {
      totalPremium = 0;
      premium = 0;
      tax = 0;
    }
  } else if (passedFrom == "personalAccidentRenewal") {
    // For Personal Accident Renewal, use the price prop which contains the total premium from PolicyViewResponse
    if (price && price > 0) {
      totalPremium = price;
      premium = price / 1.1; // Approximate base premium (total / 1.1)
      tax = price - premium; // Approximate VAT
    } else {
      totalPremium = 0;
      premium = 0;
      tax = 0;
    }
  } else if (passedFrom == "homeRenewal") {
    // For Home Renewal, use the price prop which contains the total premium
    if (price && price > 0) {
      totalPremium = price;
      premium = price / 1.1; // Approximate base premium (total / 1.1)
      tax = price - premium; // Approximate VAT
    } else {
      totalPremium = 0;
      premium = 0;
      tax = 0;
    }
  } else if (passedFrom == "personalCyberRenewal") {
    // For Personal Cyber Renewal, read exact values from policyPremiumResponse
    // (the /policy/premium API result stored in Redux). Falling back to
    // back-calculating from price introduced rounding errors in the Tax row.
    if (policyPremiumResponse && policyPremiumResponse.TotalPremium) {
      premium = policyPremiumResponse.Premium || 0;
      tax = policyPremiumResponse.Tax || 0;
      totalPremium = policyPremiumResponse.TotalPremium || 0;
    } else if (price && price > 0) {
      // Fallback: premium API not yet resolved, approximate from total price
      totalPremium = price;
      premium = price / 1.1;
      tax = price - premium;
    } else {
      totalPremium = 0;
      premium = 0;
      tax = 0;
    }
  }
   else if (passedFrom == "domesticHelperRenewal") {
    if (price && price > 0) {
      totalPremium = price;
      premium = price / 1.1;
      tax = price - premium;
    } else {
      totalPremium = 0;
      premium = 0;
      tax = 0;
    }
  }

  const [previousPrice, setPreviousPrice] = useState(totalPremium);

  // Resolve the stable portal target rendered by NewHomePolicy
  // (#home-footer-portal). Falls back to inline rendering otherwise.
  const [stickyPortalTarget, setStickyPortalTarget] = useState(null);
  useEffect(() => {
    if (typeof document === "undefined") return;
    setStickyPortalTarget(document.getElementById("home-footer-portal"));
  }, []);


  return (
    <>
      <div className="summarypopup">
        {passedFrom === "HomeInsurance" ? (
          <HomeSummaryModal
            show={show}
            onClose={() => setShow(false)}
            homeFormData={homeFormData}
            quoteData={quoteData}
          />
        ) : (
          <ViewSummaryPopup
            show={show}
            setShow={setShow}
            formState={formState}
            setFormState={setFormState}
            passedFrom={passedFrom}
          />
        )}
      </div>

      {children}
      {(() => {
        const _footer = (
            <div className="footer bg-white border-t border-[#E5E9EB] w-full py-2 flex justify-end fixed pr-10 bottom-0 z-[50] max767:w-full max767:px-4 max767:pt-3 max767:pb-[max(2.25rem,calc(env(safe-area-inset-bottom)+1rem))] max767:inset-x-0 ipad:items-center max767:inline-block">
        {addonComponent && addonComponent}
        {show_summary &&
          totalPremium > 0 &&
          !isQuoteWithRefundLoading &&
          !isPolicyPremiumLoading &&
          !isQuoteLoader &&
          !quoteResponseError &&
          !policyPremiumError &&
          !quoteWithRefundError && (
            <div className="view_summary mr-[2%] mt-4 max767:w-full max767:flex max767:mb-2 max767:justify-between ipad:mt-0  rtl:ml-3 rtl:mr-0 flex ">
              <div
                onClick={passedFrom === "TravelRenewal" ? undefined : toggleShow}
                className={`${
                  passedFrom === "TravelRenewal" ? "" : "cursor-pointer"
                }`}
              >
                <span
                  onClick={passedFrom === "TravelRenewal" ? toggleShow : undefined}
                  className={`text-[#00384D] text-center text-base not-italic font-semibold leading-[26px] tracking-[-0.16px] underline mr-3 rtl:ml-3 rtl:mr-0 ${
                    passedFrom === "TravelRenewal" ? "cursor-pointer" : ""
                  }`}
                >
                  {t("motorInsurance.bottomStickybtnlayout.summary")}
                </span>
                
              </div>
              <strong className="text-[#1A2024] text-xl not-italic font-extrabold leading-6">
                {passedFrom === "HomeInsurance" || passedFrom === "TravelRenewal" || passedFrom === "personalAccidentRenewal" || passedFrom === "homeRenewal" || passedFrom === "personalCyberRenewal" || passedFrom === "domesticHelperRenewal" ? (
                  <span className="rtl:flex rtl:flex-row-reverse rtl:gap-1">
                    <span>{translate("BHD", "د.ب")} </span>
                    <span>{formatPremiumValue(totalPremium, "en-US", 3)}</span>
                  </span>
                ) : (
                  <span className="rtl:flex rtl:flex-row-reverse rtl:gap-1">
                    <span>{translate("BHD", "د.ب")}</span> <span>{currencyFormatter(totalPremium)}</span>
                  </span>
                )}
              </strong>
            </div>
          )}
        <div className="flex justify-end pr-0 rtl:pl-[3%] max767:w-full max767:pr-[0%]">
          <div className="flex max767:w-full max767:flex-col max767:gap-2">
            {AdditionalComponent && AdditionalComponent}
            {!hideContinueBtn && (
              <Button
                isLoading={
                  // For Home Insurance, only check relevant loaders to avoid spinner from unrelated API calls (like My Policies)
                  passedFrom === "HomeInsurance"
                    ? isLoading || isQuoteLoader || isFilesLoading || isCoverPricesLoading
                    : // For other flows (Motor, Travel, etc.), check all loaders
                      isLoading ||
                      isCarListLoader ||
                      isBanksListLoader ||
                      isSumInsuredLoader ||
                      isQuoteLoader ||
                      isGdtLoader ||
                      isFilesLoading ||
                      isTokenLoading ||
                      isScannerLoading ||
                      isTokenOtpLoading ||
                      isFetchPolicyLoading ||
                      isBankLoading == "loading" ||
                      isPolicyPremiumLoading ||
                      isQuoteWithRefundLoading ||
                      isCalculatePremiumLoading ||
                      isRequestTransferLoading ||
                      isChangePlateLoading ||
                      isPolicyPayAddCoversLoading ||
                      isAdjustSumInsuredLoading ||
                      isUploadingHistory ||
                      isCoverPricesLoading
                }
                disabled={
                  btn_disabled ||
                  quoteWithRefundError ||
                  !isInspectionDocsUploaded ||
                  isInspectionUploadFail ||
                  (totalPremium <= 0 && passedFrom == "AddCovers") ||
                  (totalPremium <= 0 && passedFrom == "TravelAddCovers") ||
                  // (totalPremium <= 0 && passedFrom == "TravelChangePlan") || // Removed - travel change plan doesn't need pricing validation
                  (totalPremium <= 0 && passedFrom == "MotorChangeActivePlan")
                }
                onSubmit={btn_onClick ? btn_onClick : () => {}}
                type="submit"
                label={
                  btn_label ||
                  t(
                    "motorInsurance.newMotorInsuranceFlow.basicInfo.continueButton"
                  )
                }
                className="mb-0 stickybutton flex w-[200px] flex-col items-center gap-2.5 shrink-0 p-4 bg-[#55C6EF] rounded-[10px] text-[#1A2024] text-center text-lg not-italic font-semibold leading-6 tracking-[-0.18px] max767:w-full max767:h-[48px] max767:py-3"
              />
            )}
          </div>
        </div>
      </div>
        );
        return stickyPortalTarget ? createPortal(_footer, stickyPortalTarget) : _footer;
      })()}
    </>
  );
};

export default BottomStickyBtnLayout;
